import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITableHoverCell from 'UIComponents/table/UITableHoverCell';
import Small from 'UIComponents/elements/Small';
import RemoveFormWorkflowDependencyButton from 'ContentComponents/cmv2/form/formAutomation/connectedWorkflows/RemoveFormWorkflowDependencyButton';
import WorkflowLink from 'ContentComponents/cmv2/form/formAutomation/connectedWorkflows/WorkflowLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.form.formWorkflowDependencies.${key}`;
const FormWorkflowDependenciesTableRow = ({
  contentId,
  formGuid,
  formWorkflowDependency,
  hasWorkflowsAppAccess,
  hasWorkflowsDeleteAccess,
  onEditWorkflowEvent,
  onRemoveWorkflowEvent,
  readOnly
}) => {
  const onWorkflowLinkClick = () => {
    if (onEditWorkflowEvent) onEditWorkflowEvent();
  };
  let actions;
  if (contentId && !readOnly) {
    actions = /*#__PURE__*/_jsx(RemoveFormWorkflowDependencyButton, {
      contentId: contentId,
      formGuid: formGuid,
      formWorkflowDependency: formWorkflowDependency,
      hasWorkflowsAppAccess: hasWorkflowsAppAccess,
      hasWorkflowsDeleteAccess: hasWorkflowsDeleteAccess,
      onRemoveWorkflowEvent: onRemoveWorkflowEvent
    });
  }
  return /*#__PURE__*/_jsx("tr", {
    children: /*#__PURE__*/_jsx(UITableHoverCell, {
      className: "p-all-4",
      hoverContent: actions,
      children: /*#__PURE__*/_jsxs(UIFlex, {
        direction: "column",
        children: [/*#__PURE__*/_jsx(WorkflowLink, {
          "data-selenium": "form-field-workflow-dependencies-workflow-link",
          formGuid: formGuid,
          formWorkflowDependency: formWorkflowDependency,
          hasWorkflowsAppAccess: hasWorkflowsAppAccess,
          onClick: onWorkflowLinkClick,
          truncate: true
        }), /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: i18nKey('dependencyRow.lastUpdated'),
            options: {
              timestamp: /*#__PURE__*/_jsx(FormattedDateTime, {
                value: formWorkflowDependency.updateMetadata.updatedAt,
                format: "lll"
              })
            }
          })
        })]
      })
    })
  });
};
export default FormWorkflowDependenciesTableRow;